import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

//STRATEGIC OBJECTIVE
export const getSustainableDevelopmentGoals = createAsyncThunk(
  "settings/getSustainableDevelopmentGoals",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/sdg`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getSustainableDevelopmentGoalDropdown = createAsyncThunk(
  "settings/getSustainableDevelopmentGoalDropdown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/sdg`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const addSDG = createAsyncThunk(
  "settings/addSDG",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/segments/sdg/add", inputData)
      if (response) {
        toast.success("SDG added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editSDG = createAsyncThunk(
  "settings/editSDG",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/segments/sdg/edit", inputData)
      if (response) {
        toast.success("SDG updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteSDG = createAsyncThunk(
  "settings/deleteSDG",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/segments/sdg/delete/${id}`, {})
      if (response) {
        toast.success("SDG deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// GEO_ZONES
export const getGeoZones = createAsyncThunk(
  "settings/getGeoZones",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/geo/zones`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const addGeoZone = createAsyncThunk(
  "settings/addGeoZone",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/zone/add", inputData)
      if (response) {
        toast.success("Geographical zone uploaded successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editGeoZone = createAsyncThunk(
  "settings/editGeoZone",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/zone/edit", inputData)
      if (response) {
        toast.success("Geographical zone updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteGeoZone = createAsyncThunk(
  "settings/deleteGeoZone",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/geo/zone/delete/${id}`, {})
      if (response) {
        toast.success("Geographical zone deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//HEADS
export const getAllStates = createAsyncThunk(
  "settings/getAllStates",
  async ({ zone }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/geo/states?zone=${zone}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const getsState = createAsyncThunk(
  "settings/getsState",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/geo/state/${id}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const addState = createAsyncThunk(
  "settings/addState",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/state/add", inputData)
      if (response) {
        toast.success("State uploaded successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editState = createAsyncThunk(
  "settings/editState",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/state/edit", inputData)
      if (response) {
        toast.success("State updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteState = createAsyncThunk(
  "settings/deleteState",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/geo/state/delete/${id}`, {})
      if (response) {
        toast.success("State deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//senatorial districts
export const getsenatorialdistrict = createAsyncThunk(
  "settings/getsenatorialdistrict",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/geo/senatorial/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const addsenatorialdistrict = createAsyncThunk(
  "settings/addsenatorialdistrict",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/senatorial/add", inputData)
      if (response) {
        toast.success("senatorial district added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editsenatorialdistrict = createAsyncThunk(
  "settings/editsenatorialdistrict",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/senatorial/edit", inputData)
      if (response) {
        toast.success("senatorial district updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deletessenatorialdistrict = createAsyncThunk(
  "settings/deletessenatorialdistrict",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/geo/senatorial/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("senatorial district deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error.message || error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//LGAs
export const getlgs = createAsyncThunk(
  "settings/getlgs",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/geo/lgs/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)
export const addlg = createAsyncThunk(
  "settings/addlg",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/lg/add", inputData)
      if (response) {
        toast.success("LGA added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editlg = createAsyncThunk(
  "settings/editlg",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/lg/edit", inputData)
      if (response) {
        toast.success("LGA updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deletelg = createAsyncThunk(
  "settings/deletelg",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/geo/lg/delete/${id}`, {})
      if (response) {
        toast.success("LGA deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error.message || error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//Wards
export const addward = createAsyncThunk(
  "settings/addward",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/ward/add", inputData)
      if (response) {
        toast.success("Ward uploaded successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editward = createAsyncThunk(
  "settings/editward",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/geo/ward/edit", inputData)
      if (response) {
        toast.success("LGA updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteward = createAsyncThunk(
  "settings/deleteward",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/geo/ward/delete/${id}`, {})
      if (response) {
        toast.success("LGA deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message = error?.response?.data || error.message || error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
const initialState = {
  data: null,
  geozones: null,
  loading: false,
  states: null,
  state: null,
  stateloading: false,
  senatorials: null,
  senatorialloading: false,
  lgs: null,
  lgsloading: false,
}

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //Sustainable development objectives
    builder.addCase(getSustainableDevelopmentGoals.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getSustainableDevelopmentGoals.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getSustainableDevelopmentGoals.rejected, (state) => {
      state.loading = false
      state.data = null
    })
    builder.addCase(
      getSustainableDevelopmentGoalDropdown.fulfilled,
      (state, { payload }) => {
        state.data = payload.data
      }
    )
    //Geo-zones
    builder.addCase(getGeoZones.pending, (state) => {
      state.loading = true
      state.geozones = null
    })
    builder.addCase(getGeoZones.fulfilled, (state, { payload }) => {
      state.loading = false
      state.geozones = payload.data
    })
    builder.addCase(getGeoZones.rejected, (state) => {
      state.loading = false
      state.geozones = null
    })

    //STATEs
    builder.addCase(getAllStates.pending, (state) => {
      state.stateloading = true
      state.states = null
    })
    builder.addCase(getAllStates.fulfilled, (state, { payload }) => {
      state.stateloading = false
      state.states = payload.data
    })
    builder.addCase(getAllStates.rejected, (state) => {
      state.stateloading = false
      state.states = null
    })
    //STATE
    builder.addCase(getsState.pending, (state) => {
      state.stateloading = true
      state.state = null
    })
    builder.addCase(getsState.fulfilled, (state, { payload }) => {
      state.stateloading = false
      state.state = payload.data
    })
    builder.addCase(getsState.rejected, (state) => {
      state.stateloading = false
      state.state = null
    })
    //senatorial
    builder.addCase(getsenatorialdistrict.pending, (state) => {
      state.senatorialloading = true
      state.senatorials = null
    })
    builder.addCase(getsenatorialdistrict.fulfilled, (state, { payload }) => {
      state.senatorialloading = false
      state.senatorials = payload.data
    })
    builder.addCase(getsenatorialdistrict.rejected, (state) => {
      state.senatorialloading = false
      state.senatorials = null
    })
    //LGs
    builder.addCase(getlgs.pending, (state) => {
      state.lgsloading = true
      state.lgs = null
    })
    builder.addCase(getlgs.fulfilled, (state, { payload }) => {
      state.lgsloading = false
      state.lgs = payload.data
    })
    builder.addCase(getlgs.rejected, (state) => {
      state.lgsloading = false
      state.lgs = null
    })
  },
})

export default settingsSlice.reducer
